import React, { useRef, useEffect } from "react"

const MobileResize = props => {
  const { children, setIsMobile } = props
  const targetRef = useRef(null)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 921)
    }
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  return <div ref={targetRef}>{children}</div>
}
export default MobileResize
